module.exports = __webpack_public_path__ + "img/product1.629c7883.jpg";